import { render } from "./NotFoundResolutionDialog.vue?vue&type=template&id=5cbf84be&ts=true"
import script from "./NotFoundResolutionDialog.ts?vue&type=script&lang=ts&external"
export * from "./NotFoundResolutionDialog.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__